import api from './client'

// Relevamiento de procesos con IA (módulo Procesos — solo super_admin)
export const entrevistasApi = {
  listar: () => api.get('/procesos/entrevistas'),
  crear: (data) => api.post('/procesos/entrevistas', data),
  detalle: (id) => api.get(`/procesos/entrevistas/${id}`),
  reabrir: (id) => api.post(`/procesos/entrevistas/${id}/reabrir`),
  eliminar: (id) => api.delete(`/procesos/entrevistas/${id}`),
}

// Portal público del empleado (sin auth — token propio)
export const entrevistaPublicaApi = {
  get: (token) => api.get(`/publico/entrevistas/${token}`),
  mensaje: (token, mensaje) => api.post(`/publico/entrevistas/${token}/mensaje`, { mensaje }),
}
